// extracted by mini-css-extract-plugin
export default {"wrapper":"WarrantyYearsInput_wrapper__TqWGQ","warning":"WarrantyYearsInput_warning__k7JIn"};